module.exports = __webpack_public_path__ + "img/nube_informacion.e98546f4.png";